import type React from 'react';
import { useEffect, useState } from 'react';

import { Player as VideoPlayer } from '@xing-com/crate-video-player';

import { useTrackVideoEnd, useTrackVideoStart } from '../../tracking';

import { TEXT_CONTENT } from './video-section-data';
import { Container, Text, VideoWrapper } from './video-section.styles';

export const VideoSection: React.FC = () => {
  const trackVideoStart = useTrackVideoStart();
  const trackVideoEnd = useTrackVideoEnd();

  const [videoId, setVideoId] = useState<string>('536140.2e4234');

  useEffect(() => {
    if (
      window.location.hostname.includes('.kenv.xing.com') ||
      window.location.hostname.includes('.oenv.xing.com')
    ) {
      setVideoId('4.83b992');
    }
  }, []);

  return (
    <Container>
      {/* @ts-expect-error FIXME: SC6 */}
      <Text size="xlarge" dangerouslySetInnerHTML={{ __html: TEXT_CONTENT }} />
      <VideoWrapper>
        <VideoPlayer
          id={videoId}
          section="career-hub-articleVideo"
          onStart={trackVideoStart}
          onComplete={trackVideoEnd}
        />
      </VideoWrapper>
    </Container>
  );
};
